export default "__VITE_ASSET__KLuc1XiY__"